import { render, staticRenderFns } from "./SftpPushDialog.vue?vue&type=template&id=2bb8550c&scoped=true&"
import script from "./SftpPushDialog.vue?vue&type=script&lang=js&"
export * from "./SftpPushDialog.vue?vue&type=script&lang=js&"
import style0 from "./SftpPushDialog.vue?vue&type=style&index=0&id=2bb8550c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb8550c",
  null
  
)

export default component.exports